export enum CONTENT_PICKER {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=78329562
     */
    PICK_CONTENT = 'ADMIN.MOBILE.NAVIGATION.PICK_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=258933438
     */
    PICK_CONTENT_FROM_YOUR_SITE = 'CONTENT_PICKER.PICK_CONTENT_FROM_YOUR_SITE',
}
